export enum ExpensesReasonEnum {
  PHONE = 'phone',
  CRM = 'crm',
  BASE = 'base',
  ARENDA = 'arenda',
  ZONT = 'zont',
  ZP_IT = 'zp-it',
  OTHER = 'other',
}
